/* global jQuery */

;(function($){
	$.shopgate = $.shopgate || {};

	/**
	 *  This plugin processes youtube video code in the shopgate product description container to provide a better representation
	 */
	$.fn.shopgateProductVideoSanitizer = function(options) {
		if (!$.shopgate.checkPluginPrerequisites('DescriptionVideo', ['$.shopgate.urlParser'])) {return this;}

		var defaults = {
				classVideoContainer: 'sg-product-video-container',
				classVideoContainerWrapper: 'sg-product-video-container-wrapper'
			},

			options = options || {};
			options = $.extend({}, defaults, options);

		return this.each(function(){
			var that = $(this);

			_updateProductDescription();

			$(document).on('shopgateFramework.ui.product.updated', function(e, data){
				_updateProductDescription();
			});

			function _updateProductDescription() {
				_replaceOldCode(that);

				// wrap the video iframes to apply the responsive styles
				that.find('iframe[src*="www.youtube.com"], iframe[src*="player.vimeo.com"]').each(function(){
					if (!$(this).parent().hasClass(options.classVideoContainer)) {
						$(this)
							.wrap($('<div>').prop('class', options.classVideoContainerWrapper))
							.wrap($('<div>').prop('class', options.classVideoContainer));
					}
				});
			}
		});

		/**
		 * Replace the old version of the youtube embed code with the new iframe version
		 * @param {jQuery-object} that Reference to the description container
		 */
		function _replaceOldCode(that) {
			that.find('object').each(function(){
				var youtubeLink = null,
					width = null,
					height = null;

				// find embed elements with youtube links
				$(this).find('embed[src*="www.youtube.com"]').each(function(){
					var path = $.shopgate.urlParser($(this).attr('src')).getPath();
					youtubeLink = path ? path.replace('youtube.com/v', 'youtube.com/embed') : '';
					width = $(this).prop('width') ? $(this).prop('width') : null;
					height = $(this).prop('height') ? $(this).prop('height') : null;
				});
				// if a link was found create a new iframe and replace the object element
				if (youtubeLink) {
					$(this).replaceWith($('<iframe>').prop({'src': youtubeLink, 'width': width, 'height': height,'frameborder': 0, 'allowfullscreen': true}));
				}
			});
		}
	};
})(jQuery);


// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/jquery.shopgate-product-video-sanitizer.js